export const RenderAnnotation = (
	svgElement: SVGSVGElement | null,
	partId: string,
	word: string,
	x: number,
	y: number,
	correct: boolean | null = null,
	handleRemoveAnnotation?: (partId: string) => void,
) => {
	if (svgElement) {
		const existingAnnotation = svgElement.getElementById(
			`annotation-${partId}`,
		);
		if (existingAnnotation) {
			svgElement.removeChild(existingAnnotation);
		}

		// Create a group to contain the rect and text
		const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
		group.id = `annotation-${partId}`;

		// Create text element
		const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
		text.setAttribute("x", x.toString());
		text.setAttribute("y", y.toString());
		text.setAttribute("fill", "black");
		text.setAttribute("font-size", "60");
		text.textContent = word;

		// Temporarily add text to SVG to calculate its bounding box
		svgElement.appendChild(text);
		const bbox = text.getBBox();
		svgElement.removeChild(text);

		// Create a rect element as background
		const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
		rect.setAttribute("x", (bbox.x - 10).toString());
		rect.setAttribute("y", (bbox.y - 5).toString());
		rect.setAttribute(
			"width",
			(bbox.width + 20 + (correct !== null ? 40 : 0)).toString(),
		);
		rect.setAttribute("height", (bbox.height + 10).toString());
		rect.setAttribute("fill", "white");
		rect.setAttribute("stroke", "black");
		rect.setAttribute("stroke-width", "2");

		// Add rect and text to group
		group.appendChild(rect);
		group.appendChild(text);

		// Add check or cross symbol if correctness is known
		if (correct !== null) {
			const symbol = document.createElementNS(
				"http://www.w3.org/2000/svg",
				"text",
			);
			symbol.setAttribute("x", (bbox.x + bbox.width + 10).toString());
			symbol.setAttribute("y", y.toString());
			symbol.setAttribute("fill", correct ? "green" : "red");
			symbol.setAttribute("font-size", "62");
			symbol.textContent = correct ? "✓" : "✗";
			group.appendChild(symbol);
		}

		// Add click event to the group
		group.addEventListener("click", () => handleRemoveAnnotation?.(partId));

		// Add the group to the SVG
		svgElement.appendChild(group);
	}
};
